import React, { PropsWithChildren } from 'react'

export interface CaseProps {
  value: string | number
}

export const Case = ({ children }: PropsWithChildren<CaseProps>) => <>{children}</>
